// extracted by mini-css-extract-plugin
export var selected = "topics-menu-item-module--selected--ee233";
export var topicIcon = "topics-menu-item-module--topicIcon--5202f";
export var topicName = "topics-menu-item-module--topicName--eaa72";
export var topicsMenuItem = "topics-menu-item-module--topicsMenuItem--b70bc";